import { Route } from "react-router-dom";
import { SimpleErrorBoundary } from "~/components";
import { lazyNamedPage } from "~/utils/routing/lazyPage";
import {
  AddParcelPageLoader,
  AddParcelPageAction,
} from "./AddParcelPage/loaders";
import {
  ParcelDetailsPageLoader,
  ParcelDetailsPageAction,
} from "./ParcelDetailsPage/loaders";
import {
  ParcelTablePageLoader,
  parcelTableShouldRevalidate,
} from "./ParcelTablePage/loaders";

const ParcelTablePage = lazyNamedPage("ParcelTablePage", () =>
  import(
    /* webpackChunkName: "parcel" */
    "./ParcelTablePage/ParcelTablePage"
  ),
);
const AddParcelPage = lazyNamedPage("AddParcelPage", () =>
  import(
    /* webpackChunkName: "parcel" */
    "./AddParcelPage/AddParcelPage"
  ),
);
const ParcelDetailsPage = lazyNamedPage("ParcelDetailsPage", () =>
  import(
    /* webpackChunkName: "parcel" */
    "./ParcelDetailsPage/ParcelDetailsPage"
  ),
);

export const ParcelPagesProtectedRoutes = () => {
  return (
    <>
      <Route
        path="/parcel"
        loader={ParcelTablePageLoader}
        shouldRevalidate={parcelTableShouldRevalidate}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<ParcelTablePage />}
      />
      <Route
        path="/add-parcel"
        loader={AddParcelPageLoader}
        action={AddParcelPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<AddParcelPage />}
      />
      <Route
        path="/parcel/:parcelID"
        loader={ParcelDetailsPageLoader}
        action={ParcelDetailsPageAction}
        ErrorBoundary={() => SimpleErrorBoundary()}
        element={<ParcelDetailsPage />}
      />
    </>
  );
};
